<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3">모델 OID 목록</div>
        <div class="setting-addel mr-l15">
          <el-button size="mini" @click="addModelOidList"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" :disabled="!isDeleted" @click="deleteModelOidList"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="isLoading" slot="body" ref="modelOidTable" :data="dataList" :columns="modelDicColumns" @selection-change="modelChangeSelection" row-class-name="c-dblclick"
    :column-default="columnDefault" @condition-change="onTableConditionChange" :total="total" remote pagination
    :show-custom-header="true" :show-search-tool="showSearchTool" @row-dblclick="onDblClickRow" style="width:100%;">
    </el-table-wrapper>
    <w-model-oid-popup ref="modelOidPopup" @reload-data="loadData" :model-popup-type="modelPopupType" :isAdd="isAdd" :editRow="editRow"></w-model-oid-popup>
  </div>
</template>

<script>
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import cloneDeep from 'lodash/cloneDeep';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import WModelOidPopup from '@/views/settings/netdevice/OidSettings/VendorModelOidSettings/popup/ModelOidPopup';
import { getValueAfterCheckEmpty } from '@/utils/string';

export default {
  name: 'WModelOidDictionaryView',
  components: {
    WModelOidPopup,
  },
  props: {
    activeTab: String,
  },
  data() {
    return {
      isLoading: false,
      columnDefault,
      total: null,
      isAdd: false,
      isDeleted: false,
      dataList: null,
      editRow: {},
      showSearchTool: false,
      modelPopupType: '',
      changeModelList: [],
      modelDicColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'objCompanyName',
          label: '벤더사 명',
          remoteProp: 'oc.obj_company_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objtypeName',
          label: '장비 종류',
          remoteProp: 'ot.objtype_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objProductId',
          label: '모델 명',
          remoteProp: 'op.obj_product_id',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objOid',
          label: '모델 OID',
          remoteProp: 'oo.obj_oid',
          width: 800,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    activeTab: {
      handler() {
        if (this.activeTab === this.$options.name) {
          this.loadData();
        }
      },
      immediate: true,
    },
    changeModelList: {
      handler() {
        if (this.changeModelList.length > 0) {
          this.isDeleted = true;
        } else {
          this.isDeleted = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * [loadData 모델 OID 목록을 가져온다.]
     * @author yelim
     */
    loadData() {
      this.isLoading = true;
      this.$nextTick(() => {
        const tableParams = this.$refs.modelOidTable.getParameter();
        const params = {
          showFlag: '1',
          ...tableParams,
        };
        NetdeviceSettingAPI.getModelOidList(params).then((result) => {
          if (result.data.success) {
            this.dataList = result.data.data;
            this.total = result.data.total;
          }
        }).finally(() => {
          this.isLoading = false;
        });
      });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [addModelOidList model oid를 추가하는 팝업을 open]
     * isAdd : 팝업에서 사용하는 콤보박스 컴포넌트를 disabled 하기 위함
     * @author yelim
     */
    addModelOidList() {
      this.editRow = {};
      this.isAdd = true;
      this.modelPopupType = 'ADD';
      this.$refs.modelOidPopup.open();
    },
    modelChangeSelection(selectVal) {
      this.changeModelList = selectVal;
    },
    /**
     * [onDblClickRow 팝업을 통해 선택할 수 있는 벤더의 항목과 그리드에 나타나는 벤더의 항목이 일치하지 않는 문제가 있음.]
     * @author yelim
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onDblClickRow(row) {
      this.isAdd = false;
      this.editRow = cloneDeep(row);
      this.modelPopupType = 'EDIT';
      this.$refs.modelOidPopup.open();
    },
    /**
     * [deleteVendorOidList 모델 OID 항목을 삭제한다.]
     * @author yelim
     */
    deleteModelOidList() {
      const action = msgUtil.action.DELETE;
      const target = '모델 OID';
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        NetdeviceSettingAPI.deleteModelInfoList(this.changeModelList).then((result) => {
          if (result.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        });
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    onTableConditionChange() {
      this.loadData();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/VendorModelOidSettings/component/ModelOidDictionaryView.vue